import type { Statements } from '../../types/Statements';

export const statementsBaseFeatureConfig: Statements = {
    hasPaging: false,
    hasSettings: false,
    sendStatementIdAsQueryParam: false,
    showCoreStatements: false,
    statementColumns: ['number', 'statementDate', 'periodicity', 'actions'],
    statementNumberVisibilityFlags: [],
    statementsBaseUrl: 'netbanking/my/securities',
    supportedStatementTypes: [],
    fileDownload: false,
};
